<template>
  <div class="card selectDisable" v-bind:style="{ order: computedOrder }">
    <div class="card-inner selectDisable" v-on:click="playSoundBlocking(soundfile)">
      <div class="card-front">
        <h1 :class="delimiter">{{ symbol }}</h1>

        <h3>&lt; <span v-html="exampleword"></span> &gt;</h3>
      </div>

      <div class="card-back selectDisable">
        <div v-bind:style="{ backgroundImage: 'url(' + imagefile + ')', backgroundSize: 'cover', height: '100%' } ">
          <!--<img :src="imagefile" style="height: 100%" class="selectDisable" draggable="false" /> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
self.url = function (url) {
  return url;
};

export default {
  name: "Card",
  props: {
    symbol: String,
    delimiter: String,
    soundfile: String,
    imagefile: String,
    exampleword: String,
    colOrder2: String,
    colOrder3: String,
    colOrder4: String,
    colOrder5: String,
    colOrder6: String,
    colOrder7: String,
  },
  computed: {
    computedOrder: function () {
      if (Number(this.$attrs.cols) == 2) {
        return this.colOrder2;
      } else if (Number(this.$attrs.cols) == 3) {
        return this.colOrder3;
      } else if (Number(this.$attrs.cols) == 4) {
        return this.colOrder4;
      } else if (Number(this.$attrs.cols) == 5) {
        return this.colOrder5;
      } else if (Number(this.$attrs.cols) == 6) {
        return this.colOrder6;
      } else if (Number(this.$attrs.cols) == 7) {
        return this.colOrder7;
      } else {
        return 1; // WELP
      }
    },
  },
  mounted: function () {
    // maybe $emit when ready?
  },
  methods: {
    bindEvents: function (audioEle) {
      //loadedmetadata
      audioEle.addEventListener("loadedMetaData", function () {
        //console.log("Loaded metadata.");

        window.current_duration =
          1000 * window.audio.duration == 0
            ? 3300
            : 1000 * window.audio.duration + 300;
      });
      // loadeddata
      audioEle.addEventListener("loadedData", function () {
        // set canPlay flag
        //console.log("loadedData!");
      });
      // play
      audioEle.addEventListener("play", function () {
        // enable preventPlay flag
        //console.log("play fired.");
        //console.log(self.$attrs);
        window.ipa_blocking = true;
      });
      audioEle.addEventListener("pause", function () {
        //console.log("pause fired");
      });
      // ended
      audioEle.addEventListener("ended", function () {
        // clear preventPlay flag
        //console.log("play ended.");
        // window.ipa_blocking = false; // Uncomment this to allow another element to play a sound the moment this audiofile has finished playing.
        // Otherwise, refer down near line 129 in the setTimeout function to change ipa_blocking behaviour.
      });
    },
    flipCardToBack: function (cardEl) {
      cardEl.getElementsByClassName("card-inner")[0].classList.add("clicked");
    },
    flipCardToFront: function (cardEl) {
      cardEl
        .getElementsByClassName("card-inner")[0]
        .classList.remove("clicked");
    },
    playSoundBlocking: function (mediapath) {
      //console.log(mediapath);

      var willPlay = false;

      if (window.ipa_blocking != undefined) {
        //console.log("at subsequent interaction");
        if (window.ipa_blocking == true) {
          // we have a track playing.  Block the event binding and injection.
          willPlay = false;
        } else {
          // Good to go - the previous
          willPlay = true;
        }
      } else {
        // Good to go - this is expected if we are at the first click interaction.
        //console.log("at first interaction");
        willPlay = true;
      }

      if (willPlay) {
        window.audio = new Audio(mediapath);
        window.current_duration = 3300; // Fallback, failsafe -- call it what you want.  This will be overwritten by our bound events:
        this.bindEvents(window.audio);

        window.audio.play();

        var clicked = this.$el;

        clicked
          .getElementsByClassName("card-inner")[0]
          .classList.add("clicked");

        setTimeout(function () {
          clicked
            .getElementsByClassName("card-inner")[0]
            .classList.remove("clicked");
          window.ipa_blocking = false;
        }, window.current_duration);
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.flipchart h1 {
  margin: revert;
  color: #FFF;
  font-size: 3rem;
  font-style: unset !important;
  font-weight: unset !important;
  font-family: "Raleway", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  -webkit-user-select: none; /* Safari */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* IE10+/Edge */
  user-select: none; /* Standard */
  margin-bottom: 0;
  padding-top: 5px;
}
.flipchart h3 {
  margin: revert;
  color: #FFF;
  font-size: 1.75rem;
  font-style: unset !important;
  font-weight: unset !important;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  -webkit-user-select: none; /* Safari */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* IE10+/Edge */
  user-select: none; /* Standard */
}
.flipchart ul {
  font-style: unset !important;
  font-weight: unset !important;
  list-style-type: none;
  padding: 0;
}
.flipchart li {
  font-style: unset !important;
  font-weight: unset !important;
  display: inline-block;
  margin: 0 10px;
}
.flipchart a {
  font-style: unset !important;
  font-weight: unset !important;
  color: #42b983;
}

span.example-emphasis {
  font-style: unset !important;
  font-weight: unset !important;
  color: #ffde59;
}

.asd {
  background-color: #49a7a1;
  background-color: #0a696f;
  background-color: #cb7144;
  background-color: #d76805;
  background-color: #ffde59;
}

.card {
  font-style: unset !important;
  font-weight: unset !important;
  width: 190px;
  height: 190px;

  display: block;

  background-color: transparent;
  margin: 5px;
  perspective: 1000px; /* Remove this if you don't want the 3D effect */
}

.card > .card-inner.clicked {
  font-style: unset !important;
  font-weight: unset !important;
  transform: rotateY(180deg);
}
.card-inner {
  font-style: unset !important;
  font-weight: unset !important;
  position: relative;
  width: 100%;
  height: 100%;
  text-align: center;
  transition: transform 0.8s;
  transform-style: preserve-3d;
}

.card > div {
  margin: initial;
}

.card-front,
.card-back {
  
  font-style: unset !important;
  font-weight: unset !important;
  border-radius: 20px;
  border: 2px solid #000;
  position: absolute;
  width: 100%;
  height: 100%;
  -webkit-backface-visibility: hidden; /* Safari */
  backface-visibility: hidden;
}

.card-front {
  font-style: unset !important;
  font-weight: unset !important;
  background-color: #49a7a1;
  color: #fff;
}
.card-back {
  font-style: unset !important;
  font-weight: unset !important;
  background-color: #0a696f;
  color: #fff;
  transform: rotateY(180deg);
}

.slash::before {
  font-style: unset !important;
  font-weight: unset !important;
  content: "/ ";
}

.slash::after {
  font-style: unset !important;
  font-weight: unset !important;
  content: " /";
}

.box::before {
  font-style: unset !important;
  font-weight: unset !important;
  content: "[ ";
}
.box::after {
  font-style: unset !important;
  font-weight: unset !important;
  content: " ]";
}

.selectDisable {
  font-style: unset !important;
  font-weight: unset !important;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -o-user-select: none;
  user-select: none;
}
</style>
